import SSIActionPlanReport from './SSIActionPlanReport';
import SSIActionPlanModule6 from './SSIActionPlanModule6';
import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';

export default [SSIActionPlanReport, AnswerSummary, SSIActionPlanModule6];
